import { AUTH_API, handleApiError } from '../../utils/axios';

export const getVisitParts = async (vin, visitId) => {
  try {
    const { data } = await AUTH_API.get(`/api/v1/vehicles/${vin}/visits/${visitId}/parts`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const createVisitPart = async (vin, visitId, part) => {
  try {
    const { data } = await AUTH_API.post(`/api/v1/vehicles/${vin}/visits/${visitId}/parts`, part);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const updateVisitPart = async (vin, visitId, partId, part) => {
  try {
    const { data } = await AUTH_API.put(`/api/v1/vehicles/${vin}/visits/${visitId}/parts/${partId}`, part);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const deleteVisitPart = async (vin, visitId, partId) => {
  try {
    const { data } = await AUTH_API.delete(`/api/v1/vehicles/${vin}/visits/${visitId}/parts/${partId}`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};
